import { Box, Text } from '@chakra-ui/react';
import { getChatEntityColor } from './entityStyles';
import { EntityItem } from './types';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';
import { RemoveComponent } from '../shared/RemoveComponent';
import { fadeInScaleAnimation } from '@texas/resources/animations/animations';

export function EntityBadge({
  entity,
  type,
  onRemove,
}: {
  entity: EntityItem;
  type: ChatMessageEntityLinkType;
  onRemove: () => void;
}) {
  return (
    <RemoveComponent onClick={onRemove} size="xs">
      <Box
        animation={fadeInScaleAnimation()}
        bg={getChatEntityColor(type)}
        px={2}
        py={1}
        borderRadius="md"
        color="white"
      >
        <Text fontSize="sm">{entity.name}</Text>
      </Box>
    </RemoveComponent>
  );
}
